import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';
import { isBXservice } from './search.utils';

const useTextOrderByAirList = (serviceType) => {
  const { t } = useTranslation(i18nNS.air);
  const { tKey } = useComponentTKey('orderByAirList');
  const newOrderByAirList = [
    {
      label: isBXservice(serviceType) ? 'Points' : t(tKey('Price')),
      icon: 'dollar',
      value: 'TotalAmount',
    },
    {
      label: t(tKey('Depart')),
      icon: 'planeDepart',
      value: 'FilterDepart',
    },
    {
      label: t(tKey('Arrive')),
      icon: 'planeArrive',
      value: 'FilterArrival',
    },
    {
      label: t(tKey('Duration')),
      icon: 'time',
      value: 'FilterDuration',
    },
  ];

  return [newOrderByAirList];
};

export default useTextOrderByAirList;
